import React, { useState } from "react";
import { Paper } from "@material-ui/core";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import imageCompression from "browser-image-compression";
import Controls from "./Controls";

export default function UploadButton(props) {
  const [imageSrc, setImageSrc] = useState();
  // props are immutable
  const { text, id, updatePhotoUrl } = props;
  async function handleImageUpload(event) {
    const imageFile = event.target.files[0];

    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };
    try {
      if (imageFile) {
        // console.log("originalFile instanceof Blob", imageFile instanceof Blob); // true
        // console.log(`originalFile size ${imageFile.size / 1024 / 1024} MB`);
        setImageSrc(imageFile);
        const reader = new FileReader();
        // reader.addEventListener("load", () => {
        //   setImageSrc(reader.result);
        // });
        // reader.readAsBinaryString(imageFile);
        const compressedFile = await imageCompression(imageFile, options); // return blob
        const compressedFileDataURL = await imageCompression.getDataUrlFromFile(
          compressedFile
        ); // return base64
        updatePhotoUrl(compressedFileDataURL);
        // console.log(
        //   "compressedFile instanceof Blob",
        //   compressedFile instanceof Blob,
        //   compressedFile,
        //   compressedFileDataURL,
        //   // reader.result,
        //   imageSrc
        // ); // true
        // console.log(
        //   `compressedFile size ${compressedFile.size / 1024 / 1024} MB`
        // ); // smaller than maxSizeMB
        // await uploadToServer(compressedFile); // write your own logic

        // Helper function
        // for advanced users only, most users won't need to use the helper functions
        // imageCompression.getDataUrlFromFile(file: File): Promise<base64 encoded string>
        // imageCompression.getFilefromDataUrl(dataUrl: string, filename: string, lastModified?: number): Promise<File>
        // imageCompression.loadImage(url: string): Promise<HTMLImageElement>
        // imageCompression.drawImageInCanvas(img: HTMLImageElement, fileType?: string): HTMLCanvasElement | OffscreenCanvas
        // imageCompression.drawFileInCanvas(file: File, options?: Options): Promise<[ImageBitmap | HTMLImageElement, HTMLCanvasElement | OffscreenCanvas]>
        // imageCompression.canvasToFile(canvas: HTMLCanvasElement | OffscreenCanvas, fileType: string, fileName: string, fileLastModified: number, quality?: number): Promise<File>
        // imageCompression.getExifOrientation(file: File): Promise<number> // based on https://stackoverflow.com/a/32490603/10395024
      }
    } catch (error) {
      // console.log(error);
    }
  }

  return (
    <div>
      <input
        accept="image/*"
        style={{ display: "none" }}
        id={id}
        // multiple
        type="file"
        name="profilePhoto"
        // value={values.profilePhoto}
        onChange={handleImageUpload}
        // error={errors.profilePhoto}
      />
      <label htmlFor={id}>
        <Controls.Button
          type="file"
          text={text}
          variant="contained"
          color="default"
          component="span"
          // className={classes.button}
          startIcon={<CloudUploadIcon />}
        />
      </label>
      {/* <Paper elevation={3} style={{ width: "210px" }}>
        {imageSrc && (
          <img
            src={imageSrc}
            width="200px"
            height="200px"
            alt="Profile"
            style={{ margin: "5px", marginBottom: "0px" }}
          />
        )}
      </Paper> */}
    </div>
  );
}
